// Browser-local registry of a no-login guest's demo uploads.
//
// A guest has no account, so there is no server-side "my sessions" list. We
// remember each demo upload in localStorage so the guest can reopen/switch
// between them. The sessions themselves persist server-side and authorize via
// their id-as-token, so these entries keep working — but only in this browser.

const KEY = 'trackapp:guestSessions';

function read() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}

function write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* localStorage may be unavailable/full — degrade silently */
  }
}

export function listGuestSessions() {
  return read();
}

export function addGuestSession({ id, name, date }) {
  if (!id) return read();
  const list = read().filter(s => s.id !== id);
  list.unshift({
    id,
    name: name || 'Untitled session',
    date: date || '',
    savedAt: Date.now(),
  });
  write(list);
  return list;
}

export function removeGuestSession(id) {
  const list = read().filter(s => s.id !== id);
  write(list);
  return list;
}
